/**
 * NAICS codes commonly used in federal government contracting.
 * Covers the sectors most relevant to IT, professional services,
 * engineering, construction, and support services.
 *
 * Source: U.S. Census Bureau NAICS 2022 classification.
 * This is not exhaustive — it covers ~200 codes across the
 * sectors that appear in 95%+ of govcon solicitations.
 */ export const NAICS_CODES = [
    // 236 — Construction of Buildings
    {
        value: '236220',
        label: '236220',
        description: 'Commercial and Institutional Building Construction'
    },
    // 237 — Heavy and Civil Engineering Construction
    {
        value: '237110',
        label: '237110',
        description: 'Water and Sewer Line Construction'
    },
    {
        value: '237310',
        label: '237310',
        description: 'Highway, Street, and Bridge Construction'
    },
    {
        value: '237990',
        label: '237990',
        description: 'Other Heavy and Civil Engineering Construction'
    },
    // 334 — Computer and Electronic Product Manufacturing
    {
        value: '334111',
        label: '334111',
        description: 'Electronic Computer Manufacturing'
    },
    {
        value: '334118',
        label: '334118',
        description: 'Computer Terminal and Other Computer Peripheral Equipment Manufacturing'
    },
    {
        value: '334210',
        label: '334210',
        description: 'Telephone Apparatus Manufacturing'
    },
    {
        value: '334290',
        label: '334290',
        description: 'Other Communications Equipment Manufacturing'
    },
    {
        value: '334511',
        label: '334511',
        description: 'Search, Detection, Navigation, Guidance, Aeronautical Systems Manufacturing'
    },
    {
        value: '334614',
        label: '334614',
        description: 'Software and Other Prerecorded Media Manufacturing'
    },
    // 336 — Transportation Equipment Manufacturing
    {
        value: '336411',
        label: '336411',
        description: 'Aircraft Manufacturing'
    },
    {
        value: '336413',
        label: '336413',
        description: 'Other Aircraft Parts and Auxiliary Equipment Manufacturing'
    },
    {
        value: '336414',
        label: '336414',
        description: 'Guided Missile and Space Vehicle Manufacturing'
    },
    {
        value: '336992',
        label: '336992',
        description: 'Military Armored Vehicle, Tank, and Tank Component Manufacturing'
    },
    // 423 — Merchant Wholesalers, Durable Goods
    {
        value: '423430',
        label: '423430',
        description: 'Computer and Peripheral Equipment and Software Merchant Wholesalers'
    },
    // 511 — Publishing Industries
    {
        value: '511210',
        label: '511210',
        description: 'Software Publishers'
    },
    // 517 — Telecommunications
    {
        value: '517111',
        label: '517111',
        description: 'Wired Telecommunications Carriers'
    },
    {
        value: '517112',
        label: '517112',
        description: 'Wireless Telecommunications Carriers (except Satellite)'
    },
    {
        value: '517210',
        label: '517210',
        description: 'Wireless Telecommunications Carriers (except Satellite)'
    },
    {
        value: '517410',
        label: '517410',
        description: 'Satellite Telecommunications'
    },
    {
        value: '517911',
        label: '517911',
        description: 'Telecommunications Resellers'
    },
    {
        value: '517919',
        label: '517919',
        description: 'All Other Telecommunications'
    },
    // 518 — Data Processing, Hosting, and Related Services
    {
        value: '518210',
        label: '518210',
        description: 'Data Processing, Hosting, and Related Services'
    },
    // 519 — Other Information Services
    {
        value: '519130',
        label: '519130',
        description: 'Internet Publishing and Broadcasting and Web Search Portals'
    },
    {
        value: '519190',
        label: '519190',
        description: 'All Other Information Services'
    },
    // 541 — Professional, Scientific, and Technical Services (THE BIG ONE)
    {
        value: '541110',
        label: '541110',
        description: 'Offices of Lawyers'
    },
    {
        value: '541199',
        label: '541199',
        description: 'All Other Legal Services'
    },
    {
        value: '541211',
        label: '541211',
        description: 'Offices of Certified Public Accountants'
    },
    {
        value: '541219',
        label: '541219',
        description: 'Other Accounting Services'
    },
    {
        value: '541310',
        label: '541310',
        description: 'Architectural Services'
    },
    {
        value: '541320',
        label: '541320',
        description: 'Landscape Architectural Services'
    },
    {
        value: '541330',
        label: '541330',
        description: 'Engineering Services'
    },
    {
        value: '541340',
        label: '541340',
        description: 'Drafting Services'
    },
    {
        value: '541350',
        label: '541350',
        description: 'Building Inspection Services'
    },
    {
        value: '541360',
        label: '541360',
        description: 'Geophysical Surveying and Mapping Services'
    },
    {
        value: '541370',
        label: '541370',
        description: 'Surveying and Mapping (except Geophysical) Services'
    },
    {
        value: '541380',
        label: '541380',
        description: 'Testing Laboratories'
    },
    {
        value: '541410',
        label: '541410',
        description: 'Interior Design Services'
    },
    {
        value: '541420',
        label: '541420',
        description: 'Industrial Design Services'
    },
    {
        value: '541430',
        label: '541430',
        description: 'Graphic Design Services'
    },
    {
        value: '541490',
        label: '541490',
        description: 'Other Specialized Design Services'
    },
    {
        value: '541511',
        label: '541511',
        description: 'Custom Computer Programming Services'
    },
    {
        value: '541512',
        label: '541512',
        description: 'Computer Systems Design Services'
    },
    {
        value: '541513',
        label: '541513',
        description: 'Computer Facilities Management Services'
    },
    {
        value: '541519',
        label: '541519',
        description: 'Other Computer Related Services'
    },
    {
        value: '541611',
        label: '541611',
        description: 'Administrative Management and General Management Consulting Services'
    },
    {
        value: '541612',
        label: '541612',
        description: 'Human Resources Consulting Services'
    },
    {
        value: '541613',
        label: '541613',
        description: 'Marketing Consulting Services'
    },
    {
        value: '541614',
        label: '541614',
        description: 'Process, Physical Distribution, and Logistics Consulting Services'
    },
    {
        value: '541618',
        label: '541618',
        description: 'Other Management Consulting Services'
    },
    {
        value: '541620',
        label: '541620',
        description: 'Environmental Consulting Services'
    },
    {
        value: '541690',
        label: '541690',
        description: 'Other Scientific and Technical Consulting Services'
    },
    {
        value: '541711',
        label: '541711',
        description: 'Research and Development in Biotechnology'
    },
    {
        value: '541712',
        label: '541712',
        description: 'Research and Development in the Physical, Engineering, and Life Sciences'
    },
    {
        value: '541715',
        label: '541715',
        description: 'Research and Development in the Social Sciences and Humanities'
    },
    {
        value: '541720',
        label: '541720',
        description: 'Research and Development in the Social Sciences and Humanities'
    },
    {
        value: '541810',
        label: '541810',
        description: 'Advertising Agencies'
    },
    {
        value: '541820',
        label: '541820',
        description: 'Public Relations Agencies'
    },
    {
        value: '541830',
        label: '541830',
        description: 'Media Buying Agencies'
    },
    {
        value: '541840',
        label: '541840',
        description: 'Media Representatives'
    },
    {
        value: '541850',
        label: '541850',
        description: 'Outdoor Advertising'
    },
    {
        value: '541860',
        label: '541860',
        description: 'Direct Mail Advertising'
    },
    {
        value: '541870',
        label: '541870',
        description: 'Advertising Material Distribution Services'
    },
    {
        value: '541890',
        label: '541890',
        description: 'Other Services Related to Advertising'
    },
    {
        value: '541910',
        label: '541910',
        description: 'Marketing Research and Public Opinion Polling'
    },
    {
        value: '541921',
        label: '541921',
        description: 'Photography Studios, Portrait'
    },
    {
        value: '541922',
        label: '541922',
        description: 'Commercial Photography'
    },
    {
        value: '541930',
        label: '541930',
        description: 'Translation and Interpretation Services'
    },
    {
        value: '541940',
        label: '541940',
        description: 'Veterinary Services'
    },
    {
        value: '541990',
        label: '541990',
        description: 'All Other Professional, Scientific, and Technical Services'
    },
    // 561 — Administrative and Support Services
    {
        value: '561110',
        label: '561110',
        description: 'Office Administrative Services'
    },
    {
        value: '561210',
        label: '561210',
        description: 'Facilities Support Services'
    },
    {
        value: '561311',
        label: '561311',
        description: 'Employment Placement Agencies'
    },
    {
        value: '561312',
        label: '561312',
        description: 'Executive Search Services'
    },
    {
        value: '561320',
        label: '561320',
        description: 'Temporary Help Services'
    },
    {
        value: '561330',
        label: '561330',
        description: 'Professional Employer Organizations'
    },
    {
        value: '561410',
        label: '561410',
        description: 'Document Preparation Services'
    },
    {
        value: '561421',
        label: '561421',
        description: 'Telephone Answering Services'
    },
    {
        value: '561422',
        label: '561422',
        description: 'Telemarketing Bureaus and Other Contact Centers'
    },
    {
        value: '561431',
        label: '561431',
        description: 'Private Mail Centers'
    },
    {
        value: '561439',
        label: '561439',
        description: 'Other Business Service Centers'
    },
    {
        value: '561440',
        label: '561440',
        description: 'Collection Agencies'
    },
    {
        value: '561450',
        label: '561450',
        description: 'Credit Bureaus'
    },
    {
        value: '561491',
        label: '561491',
        description: 'Repossession Services'
    },
    {
        value: '561499',
        label: '561499',
        description: 'All Other Business Support Services'
    },
    {
        value: '561510',
        label: '561510',
        description: 'Travel Agencies'
    },
    {
        value: '561520',
        label: '561520',
        description: 'Tour Operators'
    },
    {
        value: '561599',
        label: '561599',
        description: 'All Other Travel Arrangement and Reservation Services'
    },
    {
        value: '561611',
        label: '561611',
        description: 'Investigation Services'
    },
    {
        value: '561612',
        label: '561612',
        description: 'Security Guards and Patrol Services'
    },
    {
        value: '561613',
        label: '561613',
        description: 'Armored Car Services'
    },
    {
        value: '561621',
        label: '561621',
        description: 'Security Systems Services (except Locksmiths)'
    },
    {
        value: '561710',
        label: '561710',
        description: 'Exterminating and Pest Control Services'
    },
    {
        value: '561720',
        label: '561720',
        description: 'Janitorial Services'
    },
    {
        value: '561730',
        label: '561730',
        description: 'Landscaping Services'
    },
    {
        value: '561740',
        label: '561740',
        description: 'Carpet and Upholstery Cleaning Services'
    },
    {
        value: '561790',
        label: '561790',
        description: 'Other Services to Buildings and Dwellings'
    },
    {
        value: '561910',
        label: '561910',
        description: 'Packaging and Labeling Services'
    },
    {
        value: '561990',
        label: '561990',
        description: 'All Other Support Services'
    },
    // 611 — Educational Services
    {
        value: '611310',
        label: '611310',
        description: 'Colleges, Universities, and Professional Schools'
    },
    {
        value: '611410',
        label: '611410',
        description: 'Business and Secretarial Schools'
    },
    {
        value: '611420',
        label: '611420',
        description: 'Computer Training'
    },
    {
        value: '611430',
        label: '611430',
        description: 'Professional and Management Development Training'
    },
    {
        value: '611519',
        label: '611519',
        description: 'Other Technical and Trade Schools'
    },
    {
        value: '611699',
        label: '611699',
        description: 'All Other Miscellaneous Schools and Instruction'
    },
    {
        value: '611710',
        label: '611710',
        description: 'Educational Support Services'
    },
    // 621 — Ambulatory Health Care Services
    {
        value: '621111',
        label: '621111',
        description: 'Offices of Physicians (except Mental Health Specialists)'
    },
    {
        value: '621112',
        label: '621112',
        description: 'Offices of Physicians, Mental Health Specialists'
    },
    {
        value: '621399',
        label: '621399',
        description: 'Offices of All Other Miscellaneous Health Practitioners'
    },
    {
        value: '621410',
        label: '621410',
        description: 'Family Planning Centers'
    },
    {
        value: '621999',
        label: '621999',
        description: 'All Other Miscellaneous Ambulatory Health Care Services'
    },
    // 811 — Repair and Maintenance
    {
        value: '811210',
        label: '811210',
        description: 'Electronic and Precision Equipment Repair and Maintenance'
    },
    {
        value: '811310',
        label: '811310',
        description: 'Commercial and Industrial Machinery and Equipment Repair and Maintenance'
    },
    // 928 — National Security and International Affairs
    {
        value: '928110',
        label: '928110',
        description: 'National Security'
    },
    {
        value: '928120',
        label: '928120',
        description: 'International Affairs'
    }
];
